var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterComponent',{staticClass:"range-facet",attrs:{"displayText":_vm.facet.title}},[_vm._v(" "+_vm._s(_vm.facet.prompt)+" "),_c('RangeSlider',{attrs:{"min":_vm.facet.min,"max":_vm.facet.max},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }